<template>
  <div class="container-fluid mb-5">
      <h1>Opps Page not found</h1>

  </div>
</template>
<script>


export default {
  name: "bookmark",
  data() {
    return {
      bookmarkList: [],
      categoryList: [],
      searchkey: ''
    };
  },
 

};
</script>

<style scoped>
.card-footer {
  text-align: right;
  position: relative;
  background: #fff;
}

.pagination {
  top: 20px;
  position: absolute;
  right: 0px;
  align-content: flex-end;
  text-align: end;
}

.table td:nth-child(2) {
  text-transform: capitalize;
}
</style>